import "./app.css";
import "./custom.css";

const App = () => {
    const restaurants = [
        {
            id: "2322c681-8a2d-4810-851b-f1b9896b41d9",
            name: "Bethlehem Town",
            address: "E6/Bethlehem Road, Bethlehem, Tauranga 3110, New Zealand",
            available: true,
        },
        {
            id: "2d3dac2f-4c80-4736-98ee-90de3e4abbd3",
            name: "Brookfield - New World",
            address: "89 Bellevue Road, Brookfield, Tauranga 3110, New Zealand",
            available: true,
        },
        {
            id: "9bfaec87-dad3-407d-b82c-922c4f2b6ddd",
            name: "Crossing Shopping Food Court",
            address: "2 Taurikura Drive, Tauriko, Tauranga 3110, New Zealand",
            available: true,
        },
        {
            id: "6982524e-4f17-4db0-a2aa-adb4f4791e62",
            name: "Devonport CBD",
            address: "89 Devonport Road, Tauranga 3110, New Zealand",
            available: true,
        },
        {
            id: "1de218f9-9d3b-4653-8b45-680cea40f227",
            name: "Papamoa - Excelsa Centre",
            address: "1 Golden Sands Drive, Papamoa Beach, Papamoa, New Zealand",
            available: true,
        },
        {
            id: "65d5c9b0-d253-482a-a07b-3f4112d2af11",
            name: "Tauriko (Outside the mall)",
            address: "Taurikura Drive, Tauriko, Tauranga 3110, New Zealand",
            available: true,
        },
        {
            id: "92415a0d-52d5-4a08-926b-4e94766083e0",
            name: "The Sands - Papamoa",
            address: "255 The Boulevard, Papamoa Beach, Tauranga 3118, New Zealand",
            available: true,
        },
    ];

    const onOrder = (link) => {
        window.location.href = `https://order.tabin.co.nz/restaurant/${link}`;
    };

    return (
        <>
            <div className="restaurant-list">
                <img
                    src={`https://d1hfsnuz4i23pd.cloudfront.net/public/2026-06-17_05:14:00.164-2026-01-18_04_35_55.webp`}
                    className="restaurant-list-logo"
                    alt="logo"
                />
                <div className="select-location">Please select a location</div>
                <div className="region-content">
                    {restaurants.map((restaurant) => {
                        const isDisabled = !restaurant.available;

                        return (
                            <div className="restaurant-card" key={restaurant.id}>
                                <div className="restaurant-card-details">
                                    <div className="restaurant-name mb-2">{restaurant.name}</div>
                                    <div className="restaurant-address">{restaurant.address}</div>
                                </div>
                                <div className="restaurant-card-actions">
                                    <button
                                        type="button"
                                        className={`button ${isDisabled ? "disabled" : ""}`}
                                        disabled={isDisabled}
                                        onClick={() => {
                                            if (!isDisabled) {
                                                onOrder(restaurant.id);
                                            }
                                        }}
                                    >
                                        {restaurant.available ? "Order Here" : "Unavailable"}
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default App;
